var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Back(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "m8.79 4.988 1.118 1.638a1.005 1.005 0 0 1-.26 1.395.998.998 0 0 1-1.39-.262L6.061 4.542c-.24-.353-.232-.82.022-1.164L8.279.406A.998.998 0 0 1 9.678.197c.444.33.537.958.208 1.403L8.864 2.985 9 2.977c4.155 0 7.523 3.358 7.523 7.5 0 4.142-3.368 7.5-7.523 7.5-4.155 0-7.523-3.358-7.523-7.5.042-.529.392-.793 1.051-.793.659 0 .976.264.952.793h.003c0 3.037 2.47 5.5 5.517 5.5s5.517-2.463 5.517-5.5c0-3.038-2.47-5.5-5.517-5.5-.079 0-.149.003-.21.01Z" }) })));
}
export default Back;
